module.exports = __webpack_public_path__ + "img/text03.dc194ee0.svg";